var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { mCaption2, neutralDay, scc } from '@teamsparta/design-system';
import styled from '@emotion/styled';
var Form = function (_a) {
    var children = _a.children, label = _a.label, nudge = _a.nudge, checkAlert = _a.checkAlert, hasSingleChild = _a.hasSingleChild;
    var _b = useState(false), hasBeenFocused = _b[0], setHasBeenFocused = _b[1];
    var _c = useState(false), isFocused = _c[0], setIsFocused = _c[1];
    useEffect(function () {
        if (!hasBeenFocused && isFocused) {
            setHasBeenFocused(true);
        }
        if (hasBeenFocused && !isFocused && checkAlert) {
            checkAlert();
        }
    }, [isFocused]);
    useEffect(function () { }, [isFocused]);
    var getChildrenWithProps = function () {
        return React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    onFocus: function (e) {
                        setIsFocused(true);
                    },
                    onBlur: function (e) {
                        setIsFocused(false);
                    },
                });
            }
            return child;
        });
    };
    return (_jsxs(FormContainer, __assign({ hasSingleChild: hasSingleChild }, { children: [label && (_jsxs(FormLabel, __assign({ isFocused: isFocused }, { children: [label, nudge && _jsx("span", { children: nudge })] }))), getChildrenWithProps()] })));
};
export default Form;
var FormContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 20px;\n  box-sizing: border-box;\n  gap: ", "px;\n  background: ", ";\n  border-radius: 12px;\n  position: relative;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 20px;\n  box-sizing: border-box;\n  gap: ", "px;\n  background: ", ";\n  border-radius: 12px;\n  position: relative;\n"])), function (_a) {
    var hasSingleChild = _a.hasSingleChild;
    return (hasSingleChild ? 8 : 16);
}, neutralDay.gray0);
export var FormLabel = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n\n  span {\n    margin-left: 12px;\n    ", ";\n    color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n\n  span {\n    margin-left: 12px;\n    ", ";\n    color: ", ";\n  }\n"])), mCaption2, function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? scc.red100 : neutralDay.gray90);
}, mCaption2, neutralDay.gray60);
export var FormRowDivider = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 1px;\n  width: 100%;\n  background: ", ";\n  display: ", ";\n"], ["\n  height: 1px;\n  width: 100%;\n  background: ", ";\n  display: ", ";\n"])), neutralDay.gray20, function (_a) {
    var isHidden = _a.isHidden;
    return (isHidden ? 'none' : null);
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Form.js.map